/**
 * Menu class
 *
 * @package Ocharleys
 */

export default class Menu {
	constructor() {
		this.menuBtn = document.querySelector(".menu-toggle");

		if (!this.menuBtn) {
			return;
		}

		this.menu = document.querySelector(".nav-primary");
		this.subMenuParents = document.querySelectorAll(
			".menu-item-has-children .menu-item-dropdown"
		);
		this.toggleMenu = this.toggleMenu.bind(this);

		this.menuBtn.addEventListener("click", this.toggleMenu);

		for (const subMenuParent of this.subMenuParents) {
			subMenuParent.addEventListener(
				"click",
				this.toggleMobileSubMenu.bind(this)
			);
		}
	}

	toggleMenu(e) {
		e.preventDefault();

		// toggle menu.
		this.menuBtn.classList.toggle("active");
		this.menu.classList.toggle("active");
	}

	toggleMobileSubMenu(e) {
		e.preventDefault();

		if (!this.menu.classList.contains("active")) {
			return;
		}

		const parentListElement =
			e.currentTarget.parentElement.parentElement.parentElement;

		if (parentListElement.classList.contains("mobile-active")) {
			parentListElement.classList.remove("mobile-active");
			return;
		}

		for (const subMenuParent of this.subMenuParents) {
			subMenuParent.parentElement.parentElement.parentElement.classList.remove(
				"mobile-active"
			);
		}

		parentListElement.classList.add("mobile-active");
	}
}
